export default __webpack_public_path__ + "static/media/interior (2).9d260ed4.jpg";